export const ONBOARDING_TYPE = {
  EMAIL: 1,
  PHONE: 2,
};
